const AUTH_RETURN_TO_KEY = 'auth_return_to'

/** Safe internal path only — blocks open redirects. */
export function sanitizeReturnTo(value: string | null | undefined): string | null {
  if (!value) return null
  const trimmed = value.trim()
  if (!trimmed.startsWith('/') || trimmed.startsWith('//')) return null
  if (trimmed.startsWith('/login') || trimmed.startsWith('/register')) return null
  return trimmed
}

export function buildAuthPath(base: '/login' | '/register', returnTo?: string | null): string {
  const safe = sanitizeReturnTo(returnTo)
  if (!safe) return base
  return `${base}?next=${encodeURIComponent(safe)}`
}

export function readReturnToFromSearch(search: string): string | null {
  return sanitizeReturnTo(new URLSearchParams(search).get('next'))
}

export function stashAuthReturnTo(path: string): void {
  const safe = sanitizeReturnTo(path)
  if (safe) sessionStorage.setItem(AUTH_RETURN_TO_KEY, safe)
}

export function consumeAuthReturnTo(fallback = '/dashboard'): string {
  const fromStorage = sanitizeReturnTo(sessionStorage.getItem(AUTH_RETURN_TO_KEY))
  if (fromStorage) {
    sessionStorage.removeItem(AUTH_RETURN_TO_KEY)
    return fromStorage
  }
  return fallback
}

export function currentReturnToPath(): string {
  return `${window.location.pathname}${window.location.search}${window.location.hash}`
}
